import React from 'react'

function Card({name, description, image }) {
  return (
    <div className="w-full h-fit border-solid">
      {/* <div className="m-4 text-6xl absolute"><h2>{name}</h2></div> */}
      <div className="flex">
      <div><img src={image} alt={name} className="w-full h-full rounded-md" /></div>
      {/* <div className="text-4xl absolute"><span>{description}</span></div> */}
      </div>
    </div>
  )
}

export default Card
